import React, { useEffect, useState } from 'react'
import MappingFields from '../components/mappingFields/MappingFields'
import { documentData, mappingData } from '../data/QuestionnaireData';
import { ReactComponent as SearchIcon } from "../images/search-icon.svg";
import { ReactComponent as BackIcon } from "../images/back-icon.svg";
import { ReactComponent as DocEditIcon } from "../images/doc-edit-icon.svg";
import { ReactComponent as DocIcon } from "../images/doc-icon.svg";
import { useParams, useNavigate } from 'react-router-dom';
import DropdownInput from '../commonfields/inputs/DropdownInput';
import TextInput from '../commonfields/inputs/TextInput';
import { RoutesEnum } from '../tsmodels/RoutesModel';
import { IDropdownOptionsModel } from '../tsmodels/SharedModel';
import { IMappingModel } from '../tsmodels/QuestionnaireModel';
import { Button } from 'reactstrap';
import { getMappingList } from '../helpers/ServiceSections';
import Appservice from '../services/appservice';

const MappingsDetailsPage = () => {
  //
  const { mappingId } = useParams();
  const navigate = useNavigate();
   const service = new Appservice()

  // states
  const [mappingDetails, setMappingDetails] = useState<IMappingModel | null>();  
  const [questionSearch, setQuestionSearch] = useState("");
  const [fieldSearch, setFieldSearch] = useState("");
  const [documentSelected, setDocumentSelected] = useState<IDropdownOptionsModel | null>();
  

  // consts
  const documentsMap = documentData?.map((each) => ({
    label: each?.documentName,
    value: each?.documentId,
    data: each,
  }));

  // funcs - redirects
  const goBack = () => navigate(`/${RoutesEnum.MAPPINGS}`);

  // funcs - handlers
  const handleFieldSearch = (e: any) => {
    setFieldSearch(e?.target?.value);
  };

  const handleQuestionSearch = (e: any) => {
    setQuestionSearch(e?.target?.value);
  };

  const handleDocumentSelection = (e: any) => {
    setDocumentSelected(e)
  }
  const getMappingQuestion = () => {
    const payLoad = getMappingList;

    service
      .getQuestionnaireList(payLoad)   
      .then((res:any) => {
        setMappingDetails(res.data?.find((each:any) => each?.mappingId === mappingId))
   
      })
     
      .finally(() => {
  
      });
  };

  // useEffect
  useEffect(() => {
    if (mappingId) {
      getMappingQuestion()
    }
  }, [mappingId]); 


  return (
    <div className="mappings-details-page">
    {/* <div className="subheader-container">
      <div className="subheader-left">
        <div className="subheader-icon" onClick={goBack}>
          <BackIcon />
        </div>
        <div className="subheader-title">{mappingDetails?.mappingName}</div>
      </div>
      <div className="subheader-right">
        <Button className='generate-btn'>Generate</Button>
      </div>
    </div>

    
    <div className="subheader-container secondary">
        <div className="subheader-left">
          <div className="subheader-title">
            <span className="subheader-icon"><DocEditIcon /></span>
            {mappingDetails?.questionnaireName}
          </div>
          <div className="subheader-input-container">
            <TextInput
              className="subheader-input"
              value={questionSearch}
              onChange={handleQuestionSearch}
              placeholder="Search for question"
            />
            <SearchIcon className="search-icon" />
          </div>
        </div>
        <div className="subheader-divider"></div>
        <div className="subheader-right">
          <div className="document-mapping">
          <div className="subheader-icon"><DocIcon /></div>
            <div className="mapping-questionnire">
              <DropdownInput
                value={documentSelected}
                options={documentsMap}
                placeholder="Select a Document"
                onChange={handleDocumentSelection}
              />
            </div>
          </div>
       
          <div className="subheader-input-container">
            <TextInput
              className="subheader-input"
              value={fieldSearch}
              onChange={handleFieldSearch}
              placeholder="Search for field"
            />
            <SearchIcon className="search-icon" />
          </div>
        </div>
      </div> */}

      <div className="mapping-fields-container">
        <MappingFields  />
      </div>
    </div>
  )
}

export default MappingsDetailsPage